import React from "react";
import Markdown from "markdown-to-jsx";
import styled from "styled-components";
import { FontWeight, border } from "@glossy";
import { FontFamily } from "@glossy";

const MARKDOWN_OPTIONS = {
  forceBlock: true,
  overrides: {
    a: {
      props: {
        target: "_blank",
      },
    },
  },
};

/* default style from radarly\app\src\components\preview\web\web.m.less */
const StyledMarkdown = styled(Markdown)`
  a {
    text-decoration: underline;
  }

  p,
  dd,
  dt,
  div,
  table,
  blockquote,
  pre,
  code {
    margin: 1em 0 0.7em;
  }

  h1 {
    font-size: 1.3em;
  }

  h2 {
    font-size: 1.25em;
  }

  h3 {
    font-size: 1.2em;
  }

  h4 {
    font-size: 1.15em;
  }

  h5 {
    font-size: 1.1em;
  }

  h6 {
    font-size: 1.05em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0.5em 0;
    font-family: ${FontFamily.Sans};
  }

  ul,
  ol {
    padding: 0;
    margin: 0.5em 0 0.5em 2em;
  }

  ul {
    list-style: disc outside;
  }

  ol {
    list-style: decimal outside;
  }

  li {
    line-height: 1.6em;
  }

  dt {
    font-weight: ${FontWeight.Bold};
    margin-bottom: 0.5em;
  }

  dd {
    margin: 0 0 0 1em;
  }

  blockquote {
    border-left: 4px solid;
    font-size: 0.95em;
    padding: 0 1em 0 1.4em;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th,
  td {
    font-size: 0.8em;
    line-height: 1.2;
    padding: 0.4em;
    border: 1px solid ${border};
  }

  th {
    font-weight: ${FontWeight.Bold};
    text-align: left;
  }

  img,
  iframe {
    display: block;
    max-width: 100%;
  }

  iframe {
    display: block;
    margin: 1.2em auto;
    width: 100%;
  }

  img {
    border: 1px solid;
    box-sizing: border-box;
    height: auto;
    padding: 0.15em;
  }

  label {
    color: inherit;
    float: none;
    line-height: inherit;
    padding: 0;
    width: auto;
  }

  figure {
    border: 1px solid;
    box-sizing: border-box;
    clear: left;
    display: inline-block;
    float: none;
    line-height: 1;
    margin: 0.5em auto;
    max-width: 100%;
    padding: 0.25em;
    text-align: center;

    img {
      border-width: 0;
      float: none;
      margin-left: auto;
      margin-right: auto;
      padding: 0;
    }

    div {
      margin: 0;
    }
  }

  figcaption,
  figure p,
  cite {
    clear: both;
    display: block;
    font-size: 0.7em;
    line-height: 1.5;
    margin: 0 auto;
    max-width: 98%;
  }

  figcaption,
  cite {
    font-style: italic;
    text-rendering: optimizeLegibility;

    p {
      margin: 0 auto;
    }
  }

  p > cite,
  a > cite {
    clear: none;
    display: inline-block;
    font-size: 1em;
  }

  a > cite {
    text-decoration: underline;
  }

  pre,
  code {
    max-width: 100%;
    overflow: auto;
    white-space: pre;
    word-wrap: break-word;
    text-align: left;
  }

  code {
    background-color: transparent;
    white-space: pre-wrap;
  }

  img + cite {
    margin-top: 0.3em;
  }

  em {
    font-style: italic;
  }

  strong {
    font-weight: bold;
  }
`;

interface IProps {
  md: string;
  className?: string;
}

const UiKitMarkdown = ({ md, className }: IProps) => (
  <StyledMarkdown
    className={className}
    options={MARKDOWN_OPTIONS}
    children={md}
  />
);

export default UiKitMarkdown;
